import React, { useEffect, useState, useRef } from "react";
import configs from "../Constants";
import axios from "axios";
import TablePagination from "@mui/material/TablePagination";
import SearchIcon from "@mui/icons-material/Search";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-responsive-list";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

import {
  Box,
  TextField,
  Button,
  DialogActions,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import DeleteDiaologue from "./sub_comp/Delete";
import { printReceipt } from "./util";
import { useIntl } from "react-intl";
import Currencies from "../root/currency";
import PlaceAutocomplete from "./sub_comp/PlaceAutocomplete";
const Customers = () => {
  const [customerData, setCustomerData] = useState([]);
  const [editedData, setEditedData] = useState([]);
  const [name, setName] = useState("");
  const [mobileNo, setMoblileNo] = useState(0);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [edit, setEdit] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const [filterPro, setFilterPro] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [openView, setOpenView] = useState(false);
  const [customerOrders, setCustomerOrders] = useState([]);
  const [totalSpent, setTotalSpent] = useState(0);


  const [pendingAmount, setPendingAmount] = useState(0);
const [openRepayment, setOpenRepayment] = useState(false);
const [totalBalance, setTotalBalance] = useState(0);
const [payingNow, setPayingNow] = useState("");
const [balanceAfter, setBalanceAfter] = useState(0);
const [repaymentMode, setRepaymentMode] = useState("Cash");
const [repaymentAmount, setRepaymentAmount] = useState("");
const [selectedCustomerId, setSelectedCustomerId] = useState(null);
const [selectedCustomer, setSelectedCustomer] = useState(null);
const [repaymentName, setRepaymentName] = useState("");


  let domain =
    window.location.href.indexOf("localhost") > 0
      ? "https://menu.merchantnations.com"
      : window.location.origin;

  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const merchCode = merchantData ? merchantData.merchantCode : "";
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  console.log(userData);
  const userId = userData ? userData.sub : " ";
  let baseURL = configs.baseURL;
  let authApi = configs.authapi;
  let menuApi = configs.menuapi;
  const { formatMessage: t } = useIntl();

  // Currency formatter
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });

  console.log(`${authApi}/api/customer/${userId}`);

  let userToken = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : "";
  // let userToken =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2NTZmMmE2ODc0YTRkNjIzYmJlM2Q1ODAiLCJyb2xlIjoiQWRtaW4iLCJpYXQiOjE3NDQyNjUxNTAsImV4cCI6MTc0NDg2OTk1MH0.NmI9JEM2gChfmIL9R8eR3XVpjLom4PUdKx0NTD_0bCE";
  console.log(userToken);
  const getCustomerList = () => {
    axios({
      method: "get",
      url: `${authApi}/user/customers?merchantCode=${merchCode}&t=${new Date().getTime()}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }).then((res) => {
      console.log("Customer API Response:", res.data);
      const data = res.data;
      let customers = [];
      if (Array.isArray(data)) {
        customers = data;
      } else if (data && Array.isArray(data.customers)) {
        customers = data.customers;
      } else if (data && Array.isArray(data.data)) {
        customers = data.data;
      } else if (data && typeof data === 'object') {
        // Fallback if data is an object but doesn't match above, check if values are arrays
        const possibleArray = Object.values(data).find(val => Array.isArray(val));
        if (possibleArray) customers = possibleArray;
      }
      setCustomerData(customers);
    }).catch((err) => {
      console.error("Error fetching customers:", err);
      setCustomerData([]);
    });
  };
  useEffect(() => {
    if (!customerData.length) {
      getCustomerList();
    }
  }, []);
  const handleSubmit = () => {
    console.log(mobileNo);
    axios
      .put(`${authApi}/customer/${editedData.id}?merchantCode=${merchCode}`, {
        phone: mobileNo !== 0 ? mobileNo : editedData.phone,
        firstName: name !== "" ? name : editedData.firstName,
        address: address !== "" ? address : editedData.address,
        email: email !== "" ? email : editedData.email,
        merchantCode: merchCode,
      }, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        setEdit(false);
        getCustomerList();
      });
  };
  const handleDelete = (id) => {
    // console.log(id);
    // axios.delete(`https://authapi.digitallive24.com/customer/${deleteItemId}`).then((response) => {
    //     getCustomerList();
    // });
    const customer = customerData.find((cust) => cust.id === id);
    setDeleteItemName(customer?.firstName || "this customer");
    setDeleteItemId(id);
    setOpenDeleteDialog(true);
  };
  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleConfirmDelete = () => {
    if (deleteItemId) {
      axios.delete(`${authApi}/customer/${deleteItemId}?merchantCode=${merchCode}`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }).then((response) => {
        getCustomerList();
      });
    }
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
const fetchCustomerCredit = async (customerId) => {

  try {

    const res = await axios.get(`${configs.baseURL}/api/cust_credits`, {
      params: {
        customerId: customerId,
        merchantId: merchCode
      }
    });

    const credits = res.data;

    if (credits.length > 0) {

      const latestTransaction = credits[credits.length - 1];

      const currentBalance = latestTransaction.balanceAfter;

      setTotalBalance(currentBalance);
      setBalanceAfter(currentBalance);

    } else {

      setTotalBalance(0);
      setBalanceAfter(0);

    }

  } catch (err) {

    console.log("Credit fetch error:", err);

  }

};
const handleRepayment = (customer) => {

  setSelectedCustomerId(customer.id);
  setRepaymentName(customer.firstName);

  fetchCustomerCredit(customer.id);

  setPayingNow("");

  setOpenRepayment(true);

};
const handlePayingNow = (e) => {
  const value = Number(e.target.value);
  setPayingNow(value);

  const remaining = totalBalance - value;
  setBalanceAfter(remaining >= 0 ? remaining : 0);
};
const handleRepaymentSubmit = async () => {

  if (Number(payingNow) > totalBalance) {
    alert("Payment cannot be greater than balance");
    return;
  }

  const newBalance = totalBalance - Number(payingNow);

  try {

    await axios.post(
      `${configs.baseURL}/api/cust_credits`,
      {
        transactionId: Date.now().toString(),
        customerId: selectedCustomerId,
        merchantId: merchCode,
        type: "repayment",   
        amount: Number(payingNow),
        balanceAfter: newBalance,
        paymentMethod: repaymentMode
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      }
    );

    alert("Repayment saved successfully");

    setOpenRepayment(false);

  } catch (err) {
    console.log(err);
  }

};
  const handleEdit = async (id) => {
    // setEdit(true);
    console.log(id);
    try {
      if (id) {
        await axios.get(`${authApi}/customer/${id}?merchantCode=${merchCode}`, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }).then((res) => {
          console.log(res.data);
          const data = res.data;
          setEditedData(data);

          setName(data.firstName || "");
          setMoblileNo(data.phone || "");
          setAddress(data.address || "");
          setEmail(data.email || "");
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setEdit(true);
    }
  };
  const filterCustomers = (e) => {
    console.log(customerData);
    let val = e.target.value;
    let fltData = customerData.filter(
      (pro) =>
        pro.firstName.toLowerCase().indexOf(val.toLowerCase()) !== -1 ||
        pro.phone.indexOf(val.toLowerCase()) !== -1 ||
        pro.email.indexOf(val.toLowerCase()) !== -1 ||
        pro.address.indexOf(val.toLowerCase()) !== -1
    );
    setFilterPro(fltData);
    setIsSearch(val ? true : false);
  };
  // const handleView = async (id) => {
  //   console.log("Testing Customer Report API:", id);

  //   axios
  //     .get(`${configs.baseURL}/api/orders/customer/${id}`, {
  //       headers: {
  //         Authorization: `Bearer ${userToken}`,
  //       },
  //     })
  //     .then((res) => {
  //       console.log("API Working:", res.data);
  //       // later: show popup here
  //     })
  //     .catch((err) => {
  //       console.log("API Error:", err);
  //     });
  // };
  const handleView = async (customer) => {
    try {
      setSelectedCustomerId(customer.id);
      setSelectedCustomer(customer);
      setRepaymentName(customer.firstName);
      const res = await axios.get(
        `${configs.baseURL}/api/orders/customer/${customer.id}`,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      let orders = res.data;

      // If API returns nested arrays, flatten them
      orders = orders.flat();

      setCustomerOrders(orders);

      // 1️⃣ Total Spent Calculation
      const total = orders.reduce((sum, order) => sum + (order.totalPrice || 0), 0);
      setTotalSpent(total);

      // 2️⃣ Pending Payments (isPaid === false)
      const pending = orders
        .filter((order) => order.isPaid === false)
        .reduce((sum, order) => sum + (order.totalPrice || 0), 0);

      setPendingAmount(pending);

      setOpenView(true);
    } catch (err) {
      console.log("API Error:", err);
    }
  };


  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleMobileNo = (e) => {
    setMoblileNo(e.target.value);
  };
  const handleAddress = (e) => {
    setAddress(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleClose = () => {
    setEdit(false);
  };
  const printRef = useRef();
  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;

    const newWindow = window.open("", "", "width=900,height=700");

    newWindow.document.write(`
    <html>
      <head>
        <title>Customer Order History</title>
        <style>
          body { font-family: Arial, Helvetica, sans-serif; padding: 20px; }

          h2, h3, h4, p { margin: 4px 0; }

          .order-box {
            border: 1px solid #ddd;
            padding: 12px;
            margin-bottom: 20px;
            border-radius: 8px;
          }

          .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }

          .items-table th {
            text-align: left;
            padding: 6px;
            background: #f2f2f2;
            font-weight: bold;
            border-bottom: 1px solid #ccc;
          }

          .items-table td {
            padding: 6px;
            border-bottom: 1px solid #eee;
          }

        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };

  let productItems = isSearch ? filterPro : customerData;
  return (
    <div className="container">
      <div className="header" style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center' }}>
        <h4 style={{ margin: 0 }}>Customers</h4>
        <div className="search">
          <SearchIcon style={{ marginRight: '5px', color: '#888' }} />
          <input
            type="text"
            onChange={filterCustomers}
            placeholder="Enter Customer Details"
            style={{
              border: "none",
              outline: "none",
              width: "87%",
              backgroundColor: "transparent",
            }}
          />
        </div>
        <div></div>
      </div>
      <div className="product-list" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
        <Table width="100%" cellPadding="4px">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Mobile Number</Th>
              <Th>Address</Th>
              <Th>Email ID</Th>
              {/* <Th>Created Date</Th> */}
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {productItems.length
              ? productItems
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((customer, index) => {
                  return (
                    <Tr
                      key={customer.id || index}
                      style={{
                        borderBottom: "1px solid #f0eeee",
                        backgroundColor: index % 2 === 0 ? "transparent" : "#f5f9ff",
                        margin: "5px",
                      }}
                    >
                      <Td style={{ fontWeight: 'bold' }}>{customer.firstName}</Td>
                      <Td>{customer.phone}</Td>
                      <Td>{customer.address}</Td>
                      <Td>{customer.email}</Td>
                      {/* <Td>
                        {moment(customer.createdDate).format(
                          "h:mm a  DD MMM YYYY"
                        )}
                      </Td> */}
                      <Td align="center">
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <IconButton
                            aria-label="edit"
                            size="large"
                            color="info"
                            onClick={() => handleEdit(customer.id)}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            aria-label="view"
                            size="large"
                            color="primary"
                            onClick={() => handleView(customer)}
                          >
                            <ReceiptLongIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            size="large"
                            color="error"
                            onClick={() => handleDelete(customer.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              : ""}
          </Tbody>
        </Table>
        {customerData && customerData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={customerData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </div>
      {openDeleteDialog === true ? (
        <DeleteDiaologue
          open={openDeleteDialog}
          onClose={handleDeleteClose}
          onConfirm={handleConfirmDelete}
          itemName={deleteItemName}
        />
      ) : (
        <div />
      )}
      <Dialog open={edit} onClose={handleClose} maxWidth="md">
        <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Customer Data
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <form
            style={{
              padding: "18px",
              paddingLeft: "18px",
              paddingTop: "5px",
            }}
          >
            <div className="row">
              <div>
                <Box
                  sx={{ width: 500, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Name</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    onChange={handleName}
                    value={name}
                  />
                </Box>
              </div>

              <div>
                <Box
                  sx={{ width: 300, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Mobile Number</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    type="number"
                    onChange={handleMobileNo}
                    name="Mobile Number"
                    value={mobileNo}
                  />
                </Box>
              </div>
            </div>

            <div className="row">
              <div>
                <Box
                  sx={{ width: 500, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Address</label>
                  <PlaceAutocomplete
                    apiKey="AIzaSyDFUUvF4IKg-pTy_Lmhn1_Q9Dh_4f-uHI8"
                    onPlaceSelected={(place) => {
                      setAddress(place.formatted_address || place.name || "");
                    }}
                    options={{
                      types: ["address"],
                    }}
                    defaultValue={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Address"
                    style={{
                      width: "100%"
                    }}
                  />
                </Box>
              </div>

              <div>
                <Box
                  sx={{ width: 500, maxWidth: "100%" }}
                  noValidate
                  autoComplete="off"
                >
                  <label>Email Id</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    onChange={handleEmail}
                    name="description"
                    value={email}
                  />
                </Box>
              </div>
            </div>
          </form>
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
            color="error"
            style={{ margin: "8px" }}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="success"
            style={{ margin: "8px", background: "#f7c919" }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openView} onClose={() => setOpenView(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", pb: 1 }}>
          Customer Purchase Report
        </DialogTitle>

        <DialogContent dividers ref={printRef} sx={{ p: 2 }}>
          <style>
            {`
        @media print {
          .ui-table, .print-btn-icon { display: none !important; }
          .print-table { display: block !important; }
        }
        .print-table { display: none; }
        .order-box {
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 12px;
          background: #fafafa;
          margin-bottom: 12px;
        }
        .flex-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 6px;
        }
        .summary-box {
          display: flex;
          justify-content: space-between;
          padding: 12px;
          background: #f0f7ff;
          border-radius: 8px;
          margin-bottom: 16px;
        }
      `}
          </style>

          <div className="summary-box">
            <h4 style={{ margin: 0 }}>Total Purchase: <strong>${totalSpent.toFixed(2)}</strong></h4>
            <h4 style={{ margin: 0, color: pendingAmount > 0 ? "red" : "green" }}>
              Pending Payment: <strong>${pendingAmount.toFixed(2)}</strong>
            </h4>
          </div>

          {customerOrders.length === 0 ? (
            <p style={{ textAlign: "center", padding: "20px" }}>
              This customer has no order history.
            </p>
          ) : (
            customerOrders.map((order) => (
              <Box className="order-box" key={order.id}>
                <div className="flex-row">
                  <h4 style={{ margin: 0 }}>Order #{order.number || "N/A"}</h4>
                  <h4 style={{ margin: 0 }}>${order.totalPrice}</h4>
                </div>
                
                <div className="flex-row" style={{ fontSize: "0.9rem", color: "#555" }}>
                  <span>{moment(order.createdAt).format("DD MMM YYYY, h:mm a")}</span>
                  <span>
                    Payment: <strong style={{ color: order.isPaid ? "green" : "red" }}>{order.isPaid ? "Paid" : "Pending"}</strong>
                  </span>
                </div>

                <div className="flex-row" style={{ marginTop: "8px" }}>
                  <h5 style={{ margin: 0 }}>Items:</h5>
                  <IconButton
                    aria-label="print"
                    size="small"
                    color="primary"
                    className="print-btn-icon"
                    onClick={() => {
                      const printOrd = { ...order };
                      if (selectedCustomer) {
                        printOrd.customerName = printOrd.customerName || selectedCustomer.firstName;
                        printOrd.customerPhone = printOrd.customerPhone || selectedCustomer.phone;
                        printOrd.customerAddress = printOrd.customerAddress || selectedCustomer.address;
                      }
                      printOrd.invoiceNo = printOrd.invoice_path || printOrd.invoicePath || printOrd.invoice_no || printOrd.invoiceNo || "-";
                      printOrd.cashier = userData?.firstName || userData?.name || merchantData?.firstName || "";
                      printOrd.receiptNote = merchantData?.receiptNotes || "";
                      printReceipt(printOrd, merchantData, [], t, formatter);
                    }}
                    style={{ padding: 2 }}
                  >
                    <PrintIcon fontSize="small" />
                  </IconButton>
                </div>

                <Table className="ui-table" width="100%" cellPadding="2px" style={{ fontSize: "0.85rem", marginTop: "4px" }}>
                  <Thead>
                    <Tr>
                      <Th style={{ padding: "4px" }}>Item Name</Th>
                      <Th style={{ padding: "4px" }}>Qty</Th>
                      <Th style={{ padding: "4px" }}>Price</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {order.orderItems?.map((item) => (
                      <Tr key={item._id}>
                        <Td style={{ padding: "4px" }}>{item.name}</Td>
                        <Td style={{ padding: "4px" }}>{item.quantity}</Td>
                        <Td style={{ padding: "4px" }}>${item.price}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>

                <div
                  className="print-table"
                  dangerouslySetInnerHTML={{
                    __html: `
                <table style="width:100%; border-collapse: collapse; margin-top:8px; font-size: 0.85rem;">
                  <thead>
                    <tr style="background:#f2f2f2;">
                      <th style="padding:4px; text-align:left;">Item Name</th>
                      <th style="padding:4px; text-align:left;">Qty</th>
                      <th style="padding:4px; text-align:left;">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${order.orderItems
                        .map(
                          (item) => `
                          <tr>
                            <td style="padding:4px; border-bottom: 1px solid #eee;">${item.name}</td>
                            <td style="padding:4px; border-bottom: 1px solid #eee;">${item.quantity}</td>
                            <td style="padding:4px; border-bottom: 1px solid #eee;">$${item.price}</td>
                          </tr>
                        `
                        )
                        .join("")}
                  </tbody>
                </table>
              `,
                  }}
                ></div>
              </Box>
            ))
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button variant="contained" color="success" onClick={() => {
            setOpenView(false);
            handleRepayment({ id: selectedCustomerId, firstName: repaymentName });
          }}>
            MAKE PAYMENT
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          <Button variant="outlined" color="error" onClick={() => setOpenView(false)}>
            CLOSE
          </Button>
          <Button
            variant="contained"
            onClick={handlePrint}
            color="primary"
            style={{ background: "#1976d2" }}
          >
            PRINT HISTORY
          </Button>
        </DialogActions>
      </Dialog>

<Dialog open={openRepayment} onClose={() => setOpenRepayment(false)} maxWidth="sm">

  <DialogTitle style={{fontWeight:"bold"}}>
    Customer Repayment
  </DialogTitle>

  <DialogContent>

    <TextField
      label="Total Balance"
      fullWidth
      margin="normal"
      value={totalBalance}
      InputProps={{ readOnly: true }}
    />

    <TextField
      label="Paying Now"
      type="number"
      fullWidth
      margin="normal"
      value={payingNow}
      onChange={handlePayingNow}
    />

    <TextField
      label="Balance After Payment"
      fullWidth
      margin="normal"
      value={balanceAfter}
      InputProps={{ readOnly: true }}
    />

    <TextField
      label="Mode of Repayment"
      select
      fullWidth
      margin="normal"
      value={repaymentMode}
      onChange={(e)=>setRepaymentMode(e.target.value)}
      SelectProps={{ native: true }}
    >
      <option value="Cash">Cash</option>
      <option value="Card">Card</option>
      <option value="UPI">UPI</option>
      <option value="Bank">Bank Transfer</option>
    </TextField>

  </DialogContent>

  <DialogActions>

    <Button
      variant="outlined"
      color="error"
      onClick={()=>setOpenRepayment(false)}
    >
      Cancel
    </Button>

   <Button
  variant="contained"
  color="success"
  onClick={handleRepaymentSubmit}
>
  Save Payment
</Button>

  </DialogActions>

</Dialog>
    </div>
  );
};

export default Customers;
